import type { CoreApiPaginatedRequestParams, CoreApiPaginatedSortParam } from '../interfaces/core-api.interface';

export function convertPaginatedRequestParamsToString(params: CoreApiPaginatedRequestParams | null | undefined): string {
    if (!params) {
        return '';
    }
    return Object.keys(params)
        .map(key => {
            if (key === 'sort') {
                return convertSortRequestParamsToString(params.sort);
            } else {
                return `${key}=${(params as any)[key]}`;
            }
        })
        .join('&');
}

export function convertSortRequestParamsToString(sorts: CoreApiPaginatedSortParam[] | undefined | null): string {
    if (!sorts) {
        return '';
    }
    return sorts.map(sort => `sort=${sort.name},${sort.direction}`).join('&');
}

export function convertPaginatedRequestParamsToPageable(params: CoreApiPaginatedRequestParams): {
    page?: number;
    size?: number;
    sort?: string[];
} {
    return {
        page: params.page ?? undefined,
        size: params.size ?? undefined,
        sort: params.sort?.map(sortItem => `${sortItem.name},${sortItem.direction}`)
    };
}

export function hasReachTheMaxElementCountForExcelExport(elementCount: number): boolean {
    return elementCount > maxElementCountForExcelExport;
}

export const maxElementCountForExcelExport = 1000000;
